<template>
  <div class="TeamAssetList">
    <div class="row mb-4">
      <div class="col-12 d-flex justify-content-between">
        <team-asset-search />
        <team-member-filter
          v-if="hasTeam"
          v-model="teamAssetsFilterUserId"
          class="ml-4"
        />
      </div>
    </div>

    <div
      v-if="isLoading"
      class="text-center py-8"
    >
      <i class="fa fa-spinner fa-spin" />
    </div>
    <p
      v-else-if="teamAssets.length === 0"
      class="p-5"
    >
      No team asset yet!
    </p>
    <div
      v-else
      class="row"
    >
      <div
        v-for="teamAsset in teamAssets"
        :key="teamAsset.hash_id"
        class="col-3 mb-4"
      >
        <team-asset-item
          :team-asset="teamAsset"
        />
      </div>
    </div>

    <div
      v-if="canFetchNextPage"
      class="text-center py-8"
    >
      <button
        class="btn btn-primary"
        @click="fetchNextPage"
      >
        Load more
      </button>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import TeamAssetItem from './team-asset-item.vue'
import TeamAssetSearch from './team-asset-search.vue'
import TeamMemberFilter from '../team-member-filter.vue'
import { useTeamAssets } from './use-team-assets'

export default {
  name: 'TeamAssetList',
  components: { TeamMemberFilter, TeamAssetSearch, TeamAssetItem },
  setup () {
    const { teamAssets, teamAssetsFilterUserId, isLoading, canFetchNextPage, fetchNextPage } = useTeamAssets()
    const hasTeam = computed(() => Spark.hasTeam())

    return {
      teamAssets,
      teamAssetsFilterUserId,
      isLoading,
      hasTeam,
      canFetchNextPage,
      fetchNextPage
    }
  }
}
</script>

<style scoped>
.TeamAssetList {
  min-height: 10rem;
}
</style>
